module.exports = __webpack_public_path__ + "static/img/5.a3b9411e.png";